import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="misc-wrapper">
        <h1 className="mb-2 mx-2 text-primary">
          Page Not Found
        </h1>
        <p className="mb-4 mx-2 mt-4" style={{ fontSize: "20px" }}>
          The page you are looking for doesn't exist or an other error occurred.
        </p>
        <Button
          type="button"
          variant="primary"
          onClick={() => navigate("/")}
        >
          Go To Home Page
        </Button>
        <div className="mt-3">
          <img
            src="./assets/images/notfound.png"
            alt="page-misc-error-light"
            width={500}
            className="img-fluid"
          />
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
